import { TranslationGroup } from 'mm-web-core/i18n/tanslation-group';
import { mmMenuConstants } from './menu-constants';
import { en, zh } from './i18n';

export const mmMenuTranslationGroup = {
    groupName: mmMenuConstants.translationGroup,
    translations: {
        "en": en,
        "zh": zh
    }
} as TranslationGroup